import * as React from "react";
import {
  OrderTagFragment,
  MailFragment,
  ContactFragment,
  AccountFragment,
  OrderPayStatusFragment,
  ParticipantFragment,
  RemarkFragment,
  GroupNumberFragment
} from "widget/orderListColFragment";

// 表单查询部分的模型
import Model from "viewModel";

import { formatDate } from "utils/tool";

// 静态URL
import { EUrl, orderDetailUrl } from "utils/enum/url";

// 渲染日期
const renderDate = () => {
  return {
    render: text => {
      return <div style={{ padding: 8 }}>{formatDate(text)}</div>;
    }
  };
};

// 覆盖默认需要展示的字段
const overrideColoumns = (fieldInfo, containerBody, that) => {
  //const that = this;
  let fieldList: any = [],
    fieldDetail: any;
  for (const item of fieldInfo) {
    fieldDetail = Model.OrderModel.mapToColumn(item, null);

    if (!fieldDetail) continue;

    fieldDetail["render"] ||
      (fieldDetail["render"] = text => {
        return <div style={{ padding: 4 }}>{text || "-"}</div>;
      });

    switch (item) {
      case "orderStatus":
        fieldList.push({
          ...fieldDetail,
          width: 84,
          // 订单标签片段 需要传递设置的宽度值，动态计算内部元素的宽度
          ...OrderTagFragment(150)
        });
        break;
      case "isMail":
        fieldList.push({
          ...fieldDetail,
          className: "isMail",
          width: 54,
          ...MailFragment(containerBody)
        });
        break;
      case "groupNumber":
        fieldList.push({
          ...fieldDetail,
          className: "group-number",
          ...GroupNumberFragment(containerBody)
        });
        break;
      case "account":
        const setAccountValue = account => {
          that.state.createFormRef.createFormSetValue("account", account);
          that.setState({
            isQuickSearch: true
          });
        };

        fieldList.push({
          ...fieldDetail,
          ...AccountFragment(account => {
            setAccountValue(account);
          }, containerBody)
        });
        break;
      case "orderPayStatus":
        fieldList.push({
          ...fieldDetail,
          // 订单支付状态列代码片段
          ...OrderPayStatusFragment(
            (id, callback) => {
              that.props.sendGoods({ ids: id, callback });
            },
            containerBody,
            that.refresh
          )
        });
        break;
      case "contactName":
        fieldList.push({
          ...fieldDetail,
          ...ContactFragment(containerBody)
        });
        break;
      case "submitDate":
        fieldList.push({
          ...fieldDetail,
          className: "order-date",
          width: 65,
          ...renderDate()
        });
        break;
      case "verifyTime":
        fieldList.push({
          ...fieldDetail,
          className: "order-date",
          width: 64,
          ...renderDate()
        });
        break;
      case "goTime":
        fieldList.push({
          ...fieldDetail,
          className: "order-date",
          width: 64,
          ...renderDate()
        });
        break;
      case "skuName":
        fieldList.push({
          ...fieldDetail,
          width: 300,
          render: (text, record) => {
            return (
              <div style={{ padding: 8 }}>
                <a
                  className="list-link"
                  href={orderDetailUrl(EUrl.orderDetail, record.id)}
                  target="_blank"
                >
                  {text}
                </a>
              </div>
            );
          },
          onCell: () => {
            return {
              className: "td-text-algn-left"
            };
          }
        });
        break;
      // 销售数量，  （数/成/儿/婴）
      case "saleNum":
        fieldList.push({
          ...fieldDetail,
          width: 84,
          ...ParticipantFragment
        });
        break;
      // 处理建议
      case "fullRemark":
        fieldList.push({
          ...fieldDetail,
          ...RemarkFragment
        });
        break;
      // 退订失败
      case "unsubscribeRemark":
        fieldList.push({
          ...fieldDetail,
          ...RemarkFragment
        });
        break;
      // 异常原因
      case "abnormalRemark":
        fieldList.push({
          ...fieldDetail,
          ...RemarkFragment
        });
        break;
      default:
        fieldList.push(fieldDetail);
        break;
    }
  }

  fieldList.sort((a, b) => {
    return a.sort - b.sort;
  });
  return fieldList;
};

export default overrideColoumns;
